var _circle, _path, _circle2, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoFavoriteListFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 35,
    fill: "#EFF8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9075 12.5468L42.7166 26.3413L57.9387 28.5532L46.9231 39.2898L49.5228 54.4531L35.9075 47.2944L22.2922 54.4531L24.8918 39.2898L13.8762 28.5532L29.0983 26.3413L35.9075 12.5468Z",
    stroke: "#2E90FA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.9075,
    cy: 34,
    r: 11.5,
    fill: "#EFF8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0168 34.1279V33.4775C52.0168 33.0791 52.0725 32.7275 52.1838 32.4229C52.2952 32.1123 52.4739 31.8193 52.72 31.5439C52.9661 31.2627 53.2913 30.9756 53.6956 30.6826C54.0588 30.4248 54.3489 30.1934 54.5657 29.9883C54.7883 29.7832 54.9495 29.5811 55.0491 29.3818C55.1545 29.1768 55.2073 28.9453 55.2073 28.6875C55.2073 28.3066 55.0667 28.0166 54.7854 27.8174C54.5042 27.6182 54.1116 27.5186 53.6077 27.5186C53.1038 27.5186 52.6028 27.5977 52.1047 27.7559C51.6125 27.9141 51.1116 28.1221 50.6018 28.3799L49.6438 26.4551C50.2297 26.127 50.8655 25.8633 51.551 25.6641C52.2366 25.459 52.9866 25.3564 53.801 25.3564C55.0549 25.3564 56.0247 25.6582 56.7102 26.2617C57.4016 26.8594 57.7473 27.6211 57.7473 28.5469C57.7473 29.0391 57.6682 29.4668 57.51 29.8301C57.3577 30.1875 57.1233 30.5215 56.8069 30.832C56.4963 31.1367 56.1067 31.459 55.6379 31.7988C55.2864 32.0566 55.0168 32.2734 54.8293 32.4492C54.6418 32.625 54.5129 32.8008 54.4426 32.9766C54.3782 33.1465 54.3459 33.3545 54.3459 33.6006V34.1279H52.0168ZM51.7356 37.1338C51.7356 36.583 51.885 36.1963 52.1838 35.9736C52.4885 35.751 52.8547 35.6396 53.2825 35.6396C53.6985 35.6396 54.0559 35.751 54.3547 35.9736C54.6594 36.1963 54.8118 36.583 54.8118 37.1338C54.8118 37.6611 54.6594 38.042 54.3547 38.2764C54.0559 38.5107 53.6985 38.6279 53.2825 38.6279C52.8547 38.6279 52.4885 38.5107 52.1838 38.2764C51.885 38.042 51.7356 37.6611 51.7356 37.1338Z",
    fill: "#84CAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4363 45.9156C56.8569 47.5962 64.2349 42.9429 65.9155 35.5223C67.5961 28.1016 62.9429 20.7236 55.5222 19.043C48.1016 17.3624 40.7235 22.0156 39.043 29.4363C37.3624 36.8569 42.0156 44.235 49.4363 45.9156Z",
    stroke: "#EFF8FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5918 52.3927L58.8577 41.7153",
    stroke: "#2E90FA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3677 43.1717C56.4308 44.5449 62.4591 40.7429 63.8323 34.6798C65.2054 28.6166 61.4035 22.5883 55.3403 21.2152C49.2772 19.842 43.2489 23.644 41.8758 29.7071C40.5026 35.7703 44.3046 41.7986 50.3677 43.1717Z",
    stroke: "#2E90FA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFavoriteListFound);
export default __webpack_public_path__ + "static/media/no-favorite-list-found.c360233dbd09c8785a7f7cadf7f9e24a.svg";
export { ForwardRef as ReactComponent };